import type { ITarea } from "./entidades/ITarea";
import { type IFiltroPaginador, type IRespuestaApiLista, type IRespuestaApiObjeto } from "../../globales/interfaces";
import type { IRespuestaCargaMasiva } from "./entidades/IRespuestaCargaMasiva";
import api from "../../utils/api";
import type { IFiltroTarea } from "./entidades/IFiltroTarea";
import type { ITareaCancelar } from "./entidades/ITareaCancelar";
import type { IHabilitacionVisitaInstalacion } from "../Tareas/entidades/IHabilitacionVisitaInstalacion";

export class TareaModelo {
    constructor() { }
    public async obtenerListaTareas(filtro: IFiltroTarea, paginador?: IFiltroPaginador): Promise<IRespuestaApiLista<ITarea>> {
        const payload = paginador ? {
            ...filtro,
            Page: paginador.Page,
            Size: paginador.Size
        } : filtro;

        const { data } = await api.post(
            `/api/Tareas/ConsultarPorFiltro`, payload, {
            headers: {
                "Content-Type": "application/json",

            },
        });


        return data;
    }

    public async crearTarea(proyecto: ITarea): Promise<IRespuestaApiObjeto<ITarea>> {
        const { data } = await api.post(
            `/api/Tareas/Crear`, proyecto, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async editarTarea(proyecto: ITarea): Promise<IRespuestaApiObjeto<ITarea>> {
        const { data } = await api.put(
            `/api/Tareas/Actualizar`, proyecto, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async eliminarTarea(proyecto: ITarea): Promise<IRespuestaApiObjeto<boolean>> {
        const { data } = await api.delete(
            `/api/Tareas/Eliminar/${proyecto.Id}`, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async descargarPlantilla(): Promise<void> {
        const response = await api.get(`/api/Tareas/DescargarPlantilla`, {
            responseType: "blob", // 👈 para recibirlo como archivo
        });

        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo (puedes obtenerlo del header)
        const disposition = response.headers["content-disposition"];
        let filename = "Plantilla_Tarea.xlsx";
        if (disposition && disposition.includes("filename=")) {
            const match = disposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;]+)/);
            if (match && match[1]) {
                filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
        }

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Liberar URL
        window.URL.revokeObjectURL(url);
    }


    public async cargarMasiva(archivo: File): Promise<IRespuestaApiObjeto<IRespuestaCargaMasiva>> {
        const formData = new FormData();
        formData.append("archivo", archivo);

        const { data } = await api.post(`/api/Tareas/CargarMasiva`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return data;
    }

    public async cancelarTarea(datosCancelacion: ITareaCancelar): Promise<IRespuestaApiObjeto<boolean>> {
        const { data } = await api.post(
            `/api/Tareas/CancelarTarea`, datosCancelacion, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async consultarHabilitacionVisitaInstalacion(codigoEquipo: string): Promise<IRespuestaApiLista<IHabilitacionVisitaInstalacion>> {
        const { data } = await api.get(`/api/Tareas/HabilitacionVisitaInstalacion/${codigoEquipo}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return data;
    }
}
